export var BASE_URL = "http://faceidea.tk:7777";
export var UA = "MyTwin/16 CFNetwork/978.0.7 Darwin/18.6.0";
export var FACE_ALIGN_PATH = "/align";
export var FACE_CELEBRITE_PATH = "/celebrities";